import apiClient from './apiClient';

export type WorkspaceStatus = 'pending' | 'approved' | 'rejected' | 'suspended';
export type WorkspaceRole = 'admin' | 'member';
export type EventOrganizerRole = 'admin' | 'manager' | 'viewer';

export interface WorkspaceSummary {
  id: string;
  name: string;
  status: WorkspaceStatus;
  created_by?: string | null;
  reviewed_by?: string | null;
  reviewed_at?: string | null;
}

export interface WorkspaceContext extends WorkspaceSummary {
  role: WorkspaceRole | null;
  can_manage_workspace: boolean;
  can_create_events: boolean;
}

export interface OrganizerContext {
  platform_admin: boolean;
  can_access_admin: boolean;
  workspaces: WorkspaceContext[];
}

export interface WorkspaceMember {
  user_id: string;
  email: string;
  name: string;
  role: WorkspaceRole;
  is_active: boolean;
}

export interface WorkspaceInvitation {
  id: string;
  workspace_id: string;
  email: string;
  role: 'admin' | 'member';
  expires_at: string;
  accepted_at: string | null;
  created_at: string;
}

export const workspaceService = {
  getContext: () => apiClient.get<OrganizerContext>('/admin/context'),
  apply: (name: string) => apiClient.post<WorkspaceSummary>('/admin/workspaces', { name }),
  createApproved: (name: string, adminEmail: string) => apiClient.post<WorkspaceSummary>('/admin/platform/workspaces', { name, admin_email: adminEmail }),
  list: (status?: WorkspaceStatus) => apiClient.get<WorkspaceSummary[]>(`/admin/workspaces${status ? `?status=${status}` : ''}`),
  review: (id: string, status: Exclude<WorkspaceStatus, 'pending'>) => apiClient.patch<WorkspaceSummary>(`/admin/workspaces/${id}/status`, { status }),
  listMembers: (workspaceId: string) => apiClient.get<WorkspaceMember[]>(`/admin/workspaces/${workspaceId}/members`),
  invite: (workspaceId: string, email: string, role: 'admin' | 'member') => apiClient.post<WorkspaceInvitation>(`/admin/workspaces/${workspaceId}/invitations`, { email, role }),
  updateMember: (workspaceId: string, userId: string, role: 'admin' | 'member') => apiClient.patch<WorkspaceMember>(`/admin/workspaces/${workspaceId}/members/${userId}`, { role }),
  removeMember: (workspaceId: string, userId: string) => apiClient.delete<void>(`/admin/workspaces/${workspaceId}/members/${userId}`),
  acceptInvitation: (token: string) => apiClient.post<WorkspaceMember>('/admin/workspace-invitations/accept', { token }),
};

export default workspaceService;
